import {createAction} from 'redux-actions';
import {apiGet, apiPost} from '../api';

const actions = {
    search_submit: createAction('SEARCH_SUBMIT'),
    search_succeeded: createAction('SEARCH_SUCCEEDED'),
    search_failed: createAction('SEARCH_FAILED'),

    check_convertible_submit: createAction('CHECK_CONVERTIBLE_SUBMIT'),
    check_convertible_succeeded: createAction('CHECK_CONVERTIBLE_SUCCEEDED'),
    check_convertible_failed: createAction('CHECK_CONVERTIBLE_FAILED'),

    search_copy: createAction('SEARCH_COPY'),
    search_copy_succeeded: createAction('SEARCH_COPY_SUCCEEDED'),
    search_copy_failed: createAction('SEARCH_COPY_FAILED'),

    search_reset: createAction('SEARCH_RESET')
};

export default actions;

export const search = data => apiPost('agent/api/lead/search', data, actions.search_submit, actions.search_succeeded, actions.search_failed);
export const copy = data => apiGet('agent/api/lead/copy', data, actions.search_copy, actions.search_copy_succeeded, actions.search_copy_failed);
export const checkConvertible = data => apiGet('agent/api/lead/check-convertible', data, actions.check_convertible_submit, actions.check_convertible_succeeded, actions.check_convertible_failed);

export const reset = () => ({type: actions.search_reset.toString()});
